import React from "react";
import { LANGUAGES } from "../../../../../../utils/constants";
import CodeEditor from "../../../../../../components/elements/CodeEditor"; // adjust path if needed

export default function CodeBlockEditor({ block, onChange }) {
    if (!block) return null;

    const config = block.config && typeof block.config === "object" ? block.config : {};

    const updateConfig = (patch) => {
        // safest: send full block
        onChange({
            ...block,
            config: {
                ...config,
                ...patch,
            },
        });
    };

    return (
        <div className="space-y-4">
            <div>
                <label className="block text-sm font-medium mb-1">زبان</label>
                <select
                    className="w-full p-2 border rounded-lg bg-white"
                    value={config.language || "python"}
                    onChange={(e) => updateConfig({ language: e.target.value })}
                >
                    {LANGUAGES.map((lang) => (
                        <option key={lang} value={lang}>
                            {lang}
                        </option>
                    ))}
                </select>
            </div>

            <div className="flex items-center gap-6">
                <label className="flex items-center gap-2 text-sm">
                    <input
                        type="checkbox"
                        checked={!!config.editable}
                        onChange={(e) => updateConfig({ editable: e.target.checked })}
                    />
                    قابل ویرایش
                </label>

                <label className="flex items-center gap-2 text-sm">
                    <input
                        type="checkbox"
                        checked={!!config.showCompiler}
                        onChange={(e) => updateConfig({ showCompiler: e.target.checked })}
                    />
                    نمایش کامپایلر
                </label>
            </div>

            <div>
                <label className="block text-sm font-medium mb-1">کد</label>
                <CodeEditor
                    value={config.code || ""}
                    onChange={(code) => updateConfig({ code })}
                    language={config.language || "python"}
                    readOnly={!config.editable}
                    height={280}
                />
            </div>
        </div>
    );
}
